/* C-01 Section header. */
.header {
  display: grid;
  gap: var(--dimension-space-1);
  margin: 0;
}
.kicker {
  display: flex;
  align-items: center;
  gap: var(--dimension-space-2);
  color: var(--color-text-tertiary);
}
.row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: var(--dimension-space-2);
}
.title {
  margin: 0;
  min-width: 0;
  overflow-wrap: break-word;
}
.bracket {
  color: var(--color-text-tertiary);
  font-weight: 400;
  margin: 0 var(--dimension-space-1);
}
.bracket:first-child {
  margin-left: 0;
}
.quiet {
  color: var(--color-text-tertiary);
}
.rule {
  display: flex;
  align-items: center;
  gap: var(--dimension-space-2);
  margin-top: var(--dimension-space-2);
}
.rule > hr {
  flex: 1;
}
.stripeTag {
  width: 40px;
}
